import { render, staticRenderFns } from "./FighterMediaIndex.vue?vue&type=template&id=61008a22&lang=pug"
import script from "./FighterMediaIndex.vue?vue&type=script&lang=js"
export * from "./FighterMediaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports